export default "__VITE_ASSET__b7957401__"